import React from 'react';
import { Helmet } from 'react-helmet';
import PublicFooter from '../../components/global/PublicFooter';

import PublicHeader from '../../components/global/PublicHeader';

const PrivacyPolicy = () => {
  return (
    <div id="home-page">
      <Helmet>
        <title>GoAgent - Privacy Policy</title>
      </Helmet>
      <PublicHeader defaultClass="inner-menu" />
      <main id="main">
        <section id="privacy-policy" className="privacy-policy">
          <div className="container">
            <h2>Privacy Policy</h2>
            <div className="clering-goagent-block">
              
              <h3>PRIVACY &amp; COOKIE NOTICE</h3>
              <p>Contents:</p>
              <p>
                <ol>
                  <li>About this Privacy and Cookie Notice</li>
                  <li>The data we collect about you</li>
                  <li>Cookies and how we use them</li>
                  <li>How we use your personal data</li>
                  <li>How we share your personal data</li>
                  <li>International transfers</li>
                  <li>Data security</li>
                  <li>Your legal rights</li>
                  <li>Further details</li>
                </ol>
              </p>

              <h3>ABOUT THIS NOTICE</h3>
              <p>
              This Privacy and Cookie Notice provides information on how <a href="www.goagent.com.ng">www.goagent.com.ng</a> collects and processes your personal data when you visit our website or mobile applications.
              </p>
              
              <h3>THE DATA WE COLLECT ABOUT YOU?</h3>
              <p>
                We collect your personal data in order to provide and continually improve our products and services. We may collect, use, store and transfer the following different kinds of personal data about you for marketing and personal data optimization purposes. We also use advertisement enhancement services to target potential users.
                To find out more:
                <ul>
                  <li>
                    Information you provide to us: We receive and store the information you provide to us including your identity data, contact data, delivery address and financial data.
                  </li>
                  <li>
                    Information on your use of our website and/or mobile applications: We automatically collect and store certain types of information regarding your use of the goagent.com.ng including information about your searches, views, downloads and purchases.
                  </li>
                  <li>
                    Information from third parties and publicly available sources: We may receive information about you from third parties including our carriers; payment service providers; merchants/brands; and advertising service providers.
                  </li>
                </ul>
              </p>
              
              <h3>COOKIES AND HOW WE USE THEM</h3>
              <p>
                A cookie is a small file of letters and numbers that we put on your computer if you agree.
                Cookies allow us to distinguish you from other users of our website and mobile applications, which helps us to provide you with an enhanced browsing experience. For instance, we use cookies for the following purposes:
                <ul>
                  <li>
                    Recognising and counting the number of visitors and to see how visitors move around the site when they are using it (this helps us to improve the way our website works, for example by ensuring that users can find what they are looking for).
                  </li>
                  <li>
                    Identifying your preferences and subscriptions e.g., language settings, saved items, items stored in your basket and Prime membership; and
                  </li>
                  <li>
                    Sending you newsletters and commercial/advertising messages tailored to your interests.
                  </li>
                </ul>
              </p>
              <p>
              Our approved third parties may also set cookies when you use any of our platforms. Third parties include search engines, providers of measurement and analytics services, social media networks and advertising companies.
              </p>

              <h3>HOW WE USE YOUR PERSONAL DATA</h3>
              <p>
                We use your personal data to operate, provide, develop and improve the products and services that we offer, including the following:
                <ul>
                  <li>
                    Registering you as a new user;
                  </li>
                  <li>
                    Managing your relationship with us;
                  </li>
                  <li>
                    Enabling you to participate in promotions, competitions and surveys;
                  </li>
                  <li>
                    Improving our website, applications, products and services;
                  </li>
                  <li>
                    Recommending/advertising products or services which may be of interest to you;
                  </li>
                  <li>
                    Complying with our legal obligations, including verifying your identity where necessary; and
                  </li>
                  <li>
                    Detecting fraud.
                  </li>
                </ul>
              </p>

              <h3>HOW WE SHARE YOUR PERSONAL DATA</h3>
              <p>
              We may need to share your personal data with third parties for the following purposes:
              <ul>
                <li>
                  Sale of products and services: In order to deliver your products and services purchased on our platform from third parties, we may be required to provide your personal data to such third parties.
                </li>
                <li>
                  Working with third party service providers: We engage third parties to perform certain functions on our behalf. Examples include fulfilling orders for products or services, delivering packages, analyzing data, providing marketing assistance, processing payments, transmitting content, assessing and managing credit risk, and providing customer service.
                </li>
                <li>
                  Business transfers: As we continue to develop our business, we might sell or buy other businesses or services. In such transactions, customer information may be transferred together with other business assets.
                </li>
                <li>
                  Detecting fraud and abuse: We release account and other personal data to other companies and organizations for fraud protection and credit risk reduction, and to comply with the law.
                </li>
              </ul>
              </p>
              <p>
              When we share your personal data with third parties, we:
              <ul>
                <li>
                  require them to agree to use your data in accordance with the terms of this Privacy and Cookie Notice, our Privacy Policy and in accordance with the law; and
                </li>
                <li>
                  only permit them to process your personal data for specified purposes and in accordance with our instructions. We do not allow our third-party service providers to use your personal data for their own purposes.
                </li>
              </ul>
              </p>

              <h3>INTERNATIONAL TRANSFERS</h3>
              <p>
                We may transfer your personal data to locations in another country if this is permissible pursuant to applicable laws in your location. There are inherent risks in such transfers.
                In the event of international transfers of your personal data, we shall put in place measures necessary to protect your data, and we shall continue to respect your legal rights pursuant to the terms of this Privacy and Cookie Notice and applicable laws in your location. By agreeing to this Privacy and Cookie Notice, you have granted your consent for such transfers.
              </p>

              <h3>DATA SECURITY</h3>
              <p>
                We have put in place appropriate security measures to prevent your personal data from being accidentally lost, used, or accessed in an unauthorised way, altered or disclosed.
                In addition, we limit access to your personal data to those employees, agents, contractors and other third parties who have a business need to know. They will only process your personal data on our instructions, and they are subject to a duty of confidentiality.
                We have put in place procedures to deal with any suspected personal data breach and will notify you and any applicable regulator of a breach where we are legally required to do so.
              </p>

              <h3>YOUR LEGAL RIGHTS</h3>
              <p>
                It is important that the personal data we hold about you is accurate and current. Please keep us informed if your personal data changes during your relationship with us.
                Under certain circumstances, you have rights under data protection laws in relation to your personal data, including the right to access, correct or erase your personal data, object to or restrict processing of your personal data, and unsubscribe from our emails and newsletters.
              </p>
            
              <h3>FURTHER DETAILS</h3>
              <p>
                If you are looking for more information on how we process your personal data, or you wish to exercise your legal rights in respect of your personal data, please contact <a href="mailto:support@goagent.com.ng">support@goagent.com.ng</a>.
              </p>
            </div>
          </div>
        </section>
      </main>
      <PublicFooter />
    </div>
  );
};

export default PrivacyPolicy;
